import { NavLink } from 'react-router-dom';


const Sidebar = () => {
  return (
    <aside className="sidebar">
      <div className="sidebar-title">Vista de Administrador</div>
      
      <NavLink to="/admin/dashboard" className="nav-link">Dashboard Principal</NavLink>
      <NavLink to="/admin/inventario" className="nav-link">Gestión de Inventario</NavLink>
      <NavLink to="/admin/pedidos" className="nav-link">Pedidos</NavLink>
      <NavLink to="/admin/configuracion" className="nav-link">Configuración</NavLink>
      <NavLink to="/admin/bloques" className="nav-link">Gestión de Bloques</NavLink>
      <NavLink to="/admin/cupones" className="nav-link">Cupones y Ofertas</NavLink>
      
      {/* Botón de cerrar sesión al final */}
      <button className="nav-link logout-btn" onClick={() => alert('Cerrando sesión...')}>
        Cerrar Sesión
      </button>
    </aside>
  );
};

export default Sidebar;